<template>
  <sky-suffix>
    <i
      class="icon iconfont"
      :class="[item.iconClass, hasItem(item) ? 'active' : '']"
      @click="change(item)"
      v-for="item in mediaPlatForm"
      :key="item.value"
    ></i>
  </sky-suffix>
</template>
<script>
import SkySuffix from '../SkySuffix.vue';
import { mediaPlatForm } from '@/common/dictionary';
export default {
  props: {
    value: [String, Array],
    disabled: Boolean,
    isSingle: Boolean
  },
  components: { SkySuffix },
  data() {
    return {
      data: [],
      mediaPlatForm: mediaPlatForm
    };
  },
  computed: {},
  watch: {
    value: function(val) {
      if (val) {
        this.data = val.slice();
      } else {
        this.data = [];
      }
    }
  },
  mounted() {
    this.data = this.value || [];
  },
  methods: {
    change(item) {
      if (this.disabled) return false;
      if (this.hasItem(item)) {
        _.remove(this.data, val => val === item.value);
      } else {
        this.data.push(item.value);
      }
      console.log('change');
      console.log(this.data);
      this.$emit('input', this.data);
      this.$emit('change', this.data);
    },
    hasItem(item) {
      return _.indexOf(this.value, item.value) >= 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.icon {
  font-size: 26px;
  cursor: pointer;
  &.active {
    color: #409eff;
  }
  & + & {
    margin-left: 10px;
  }
}
</style>
